import { openDB } from 'idb';

const DB = 'pricecapture-db';
const VER = 2;

async function getDB() {
  return openDB(DB, VER, {
    upgrade(db) {
      if (!db.objectStoreNames.contains('queue')) {
        const store = db.createObjectStore('queue', { keyPath: 'id', autoIncrement: true });
        store.createIndex('createdAt', 'createdAt');
      }
      if (!db.objectStoreNames.contains('cache')) {
        db.createObjectStore('cache');
      }
      if (!db.objectStoreNames.contains('drafts')) {
        const d = db.createObjectStore('drafts', { keyPath: 'id', autoIncrement: true });
        d.createIndex('capturedAt', 'capturedAt');
      }
    },
  });
}

/* Stations cache */
export async function setCachedStations(list) {
  const db = await getDB();
  await db.put('cache', list, 'stations');
}
export async function getCachedStations() {
  const db = await getDB();
  return (await db.get('cache', 'stations')) || [];
}
export async function clearCachedStations() {
  try {
    const db = await getDB();
    await db.delete('cache', 'stations');
  } catch { /* noop */ }
}

/* Queue */
export async function enqueueCapture(payload) {
  // payload: { stationId, stationName, brand, serviceType, prices, lat, lng, notes, photoBlob, photoName, photoType, capturedAt }
  const db = await getDB();
  const item = { ...payload, createdAt: new Date().toISOString() };
  return await db.add('queue', item);
}

export async function getQueue() {
  const db = await getDB();
  return await db.getAll('queue');
}

export async function getQueueCount() {
  const db = await getDB();
  return await db.count('queue');
}

export async function removeFromQueue(id) {
  const db = await getDB();
  await db.delete('queue', id);
}

export async function clearQueue() {
  const db = await getDB();
  await db.clear('queue');
}

/* Borradores de tracking (fotos en sitio · precios editados después) */
const notifyDrafts = () => window.dispatchEvent(new CustomEvent('drafts-changed'));

export async function saveDraft(payload) {
  const db = await getDB();
  const id = await db.add('drafts', { ...payload, savedAt: new Date().toISOString() });
  notifyDrafts();
  return id;
}
export async function getDrafts() {
  const db = await getDB();
  const all = await db.getAll('drafts');
  return all.sort((a, b) => (a.capturedAt || '').localeCompare(b.capturedAt || ''));
}
export async function getDraftsCount() {
  const db = await getDB();
  return await db.count('drafts');
}
export async function updateDraft(id, patch) {
  const db = await getDB();
  const d = await db.get('drafts', id);
  if (!d) return;
  await db.put('drafts', { ...d, ...patch });
  notifyDrafts();
}
export async function removeDraft(id) {
  const db = await getDB();
  await db.delete('drafts', id);
  notifyDrafts();
}
